
export default function BankDetailsStep() {
    return (
        <div>
            <h2 className="h4 fw-semibold text-dark mb-4">
                Enter Bank Details
            </h2>

            <div className="card shadow-sm border-0" style={{ borderRadius: "14px" }}>
                <div className="card-body p-4">

                    <div className="d-flex gap-4">
                        <div className="mb-3 w-50">
                            <label className="form-label">
                                Account Holder Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter account holder name"
                            />
                        </div>
                        <div className="w-50">
                            <label className="form-label">
                                Bank Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter bank name"
                            />
                        </div>
                    </div>
                    <div className="d-flex gap-4">
                        <div className="mb-3 w-50">
                            <label className="form-label">
                                Account Number <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter account number"
                            />
                        </div>

                        <div className="w-50">
                            <label className="form-label">
                                IFSC Code <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter IFSC code"
                            />
                        </div>
                    </div>

                    <div className="d-flex gap-4">
                        <div className="w-50">
                            <label className="form-label">
                                Cancelled Cheque <span className="text-danger">*</span>
                            </label>
                            <input type="file" className="form-control" />
                        </div>
                        <div className="w-50"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
